import { render } from "./IconMail.vue?vue&type=template&id=556cd9e6&scoped=true"
import script from "./IconMail.vue?vue&type=script&lang=js"
export * from "./IconMail.vue?vue&type=script&lang=js"

import "./IconMail.vue?vue&type=style&index=0&id=556cd9e6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556cd9e6"]])

export default __exports__